export const USE_ONLY_BACKGROUND_PROP = false;
